import { IFileService } from './IFileService';
import { ElectronFileAdapter } from './ElectronFileAdapter';
import { WebFileAdapter } from './WebFileAdapter';
import { isElectron } from './DatabaseFactory';

let fileServiceInstance: IFileService | null = null;

/**
 * Factory function that returns the appropriate file service implementation
 * based on the current platform (Electron vs PWA)
 */
export function getFileService(): IFileService {
  if (fileServiceInstance) {
    return fileServiceInstance;
  }

  if (isElectron()) {
    console.log('[FileServiceFactory] Using Electron file adapter');
    fileServiceInstance = new ElectronFileAdapter();
  } else {
    console.log('[FileServiceFactory] Using Web file adapter');
    fileServiceInstance = new WebFileAdapter();
  }

  return fileServiceInstance;
}

/**
 * Reset the file service singleton (useful for testing)
 */
export function resetFileService(): void {
  fileServiceInstance = null;
}
